import React, {useEffect, useState} from 'react'
import {Controller, useForm} from 'react-hook-form'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle
} from '@material-ui/core'
import HookForm from '../../components/common/HookForm'
import LoadingBackdrop from '../../components/common/LoadingBackdrop'
import SelectInput from '../../components/common/inputs/SelectInput/SelectInput'
import TextInput from '../../components/common/inputs/TextInput'
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import styles from './GenericForm.module.css'
import axios from "axios"
import {Autocomplete, Grid, InputLabel, TextField} from "@mui/material";
import styled from "@emotion/styled"
import {emailRegex} from "../../util/formValidation";

type selectOption = {
  label: string
  value: number
}

interface FormData {
  id: number
  control: number
  fieldname: string
  defaultcontrol1: boolean
  defaultcontrol2: number
  defaultcontrol3: number
  defaultcontrol4: string
  defaultcontrol5: string
  defaultcontrol6: string
  displayforallguest: boolean
  items: []
  active: boolean
  delete: boolean
}

export const Input = styled("input")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`;

const Span = styled.span`
  padding-left: 0.5em;
`

export const GenericForm = ({ isGuestOpen, setIsGuestOpen, endpoint, eventId, genericid }) => {
  const formMethods = useForm()
  const {watch, getValues, setValue, register, reset, clearErrors, control} = formMethods
  const [loading, setLoading] = React.useState(false)
  const [dialogObj, setDialogObj] = React.useState({ msg: "", id: 0, title: "" })
  const [dialogMsg, setDialogMsg] = React.useState({active: false, msg: ''})
  const [ticketData, setTicketData] = React.useState({
    ticketfieldslist: [],
    tickettitle: '',
    showbuttonreassign: false,
    showbuttonunassign: false,
    ticketlookuplist: [],
  })

  const watchGuestSelection = watch('defaultcontrol-1001')
  const formatLabel = (label: string) => label?.trimEnd().replace(/0+$/, '').trimEnd()
  const fetchIdRef = React.useRef(0)

  const fetchGuestDetails = async (selectedId, guestSelectorField) => {
    if (!guestSelectorField?.onchange?.endpoint) return
    const fetchId = ++fetchIdRef.current
    var body = {}
    guestSelectorField.onchange.params?.forEach(key => {
      if (key.startsWith('fieldid')) {
        body['fieldid'] = selectedId
      } else if (key.endsWith('-id')) {
        body[key.replace('-', '')] = genericid
      } else if (key === 'eventid') {
        body['eventid'] = eventId
      }
    })
    setLoading(true)
    const { data } = await axios.post(guestSelectorField.onchange.endpoint, body)
    if (fetchId !== fetchIdRef.current) { setLoading(false); return }
    if (data.jsonString) {
      const parsedData = JSON.parse(data.jsonString)
      parsedData?.ticketfieldslist?.forEach(item => {
        if (item.fieldid === -1001) return
        const value = item['fieldvalue' + item.fieldcontrol]
        if (value != null && value !== undefined && value !== '') {
          if (item.fieldcontrol === 2) {
            const options = ticketData?.ticketlookuplist
              ?.filter((e) => e.lookupactive === 1 && e.lookupfieldid === item.fieldid)
              ?.map((t) => ({ value: t.lookupid, label: t.lookup })) ?? []
            const optionValue = options.find((o) => o.value === value) ?? null
            if (optionValue) setValue("defaultcontrol" + item.fieldid, optionValue)
          } else {
            setValue("defaultcontrol" + item.fieldid, value)
          }
        }
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    const newTicketData = {...ticketData}
    const lookupAddNew = ticketData?.ticketlookuplist?.find((e) => e.lookup === 'Add New')
    const selectedId = watchGuestSelection?.value ?? watchGuestSelection

    if (selectedId == lookupAddNew?.lookupid) {
      var tickets = newTicketData?.ticketfieldslist.map(ticket => {
        ticket.fieldreadonly = false
        return ticket
      })
      newTicketData.ticketfieldslist = tickets

      ticketData?.ticketfieldslist?.forEach(field => {
        if (field.fieldid === -1001) return
        setValue("defaultcontrol" + field.fieldid, field.fieldcontrol === 2 ? null : '')
      })
    }
    else {
      var tickets = newTicketData?.ticketfieldslist.map(ticket => {
        if (ticket.fieldid === -1001) {
          ticket.fieldreadonly = false
        }
        else {
          ticket.fieldreadonly = true
        }
        return ticket
      })
      newTicketData.ticketfieldslist = tickets

      if (selectedId != null && selectedId !== undefined) {
        const selectedGuest = ticketData?.ticketlookuplist?.find(
          (e) => e.lookupfieldid === -1001 && e.lookupid == selectedId
        )
        if (selectedGuest) {
          ticketData?.ticketfieldslist?.forEach(field => {
            if (field.fieldid === -1001) return
            setValue("defaultcontrol" + field.fieldid, field.fieldcontrol === 2 ? null : '')
          })

          const firstNameField = ticketData?.ticketfieldslist?.find(f => f.fieldlabel?.toLowerCase().includes('first name'))
          const lastNameField = ticketData?.ticketfieldslist?.find(f => f.fieldlabel?.toLowerCase().includes('last name'))
          const spaceIdx = selectedGuest.lookup.indexOf(' ')
          if (firstNameField) setValue("defaultcontrol" + firstNameField.fieldid, spaceIdx >= 0 ? selectedGuest.lookup.substring(0, spaceIdx) : selectedGuest.lookup)
          if (lastNameField) setValue("defaultcontrol" + lastNameField.fieldid, spaceIdx >= 0 ? selectedGuest.lookup.substring(spaceIdx + 1) : '')

          const guestSelectorField = ticketData?.ticketfieldslist?.find(f => f.fieldid === -1001)
          fetchGuestDetails(selectedId, guestSelectorField)
        }
      }
    }

    setTicketData(newTicketData)
  }, [watchGuestSelection])

  useEffect(() => {
    if (isGuestOpen) {
      getEventTicket()
    }
  }, [eventId, genericid, endpoint, isGuestOpen])

  const getTicketLookupDataOptions = (lookupfieldid) => {
    const seen = new Set()
    return ticketData?.ticketlookuplist
        ?.filter((e) => e.lookupactive === 1 && e.lookupfieldid === lookupfieldid)
        ?.filter((e) => {
          if (seen.has(e.lookupid)) return false
          seen.add(e.lookupid)
          return true
        })
        ?.map((t) => ({ value: t.lookupid, label: t.lookup })) ?? []
  }

  const unassignEventTicket = async () => {
    setLoading(true)
    const { data } = await axios.put('/' + endpoint, {eventid: eventId, genericid: genericid, unassign: true})
    const parsedData = JSON.parse(data.jsonString)

    setDialogObj({
      title: '',
      id: 0,
      msg: ''
    })
    if (parsedData.status === 'success') {
      setDialogMsg({active: false, msg: ''})
      setIsGuestOpen(false)
    }
    else {
      setDialogMsg({active: true, msg: parsedData.message})
    }

    setLoading(false)
  }

  const getEventTicket = async () => {
    var body = {eventid: eventId}

    if (genericid > 0) {
      body['genericid'] = genericid
    }

    setLoading(true)
    const { data } = await axios.post('/' + endpoint, body)
    const parsedData = JSON.parse(data.jsonString)
    console.log(parsedData)
    setTicketData(parsedData)

    var newFormValues = {}

    reset()
    parsedData?.ticketfieldslist?.map(item => {
      if (item.fieldcontrol === 2) {
        const options = parsedData?.ticketlookuplist
            ?.filter((e) => e.lookupactive === 1 && e.lookupfieldid === item.fieldid)
            ?.map((t) => ({ value: t.lookupid, label: t.lookup }))
        const savedValue = item['fieldvalue' + item.fieldcontrol]
        newFormValues["defaultcontrol" + item.fieldid] =
            options?.find((o) => o.value === savedValue) ?? null
      }
      else if (item.fieldcontrol === 3) {
        newFormValues["defaultcontrol" + item.fieldid] = item['fieldvalue' + item.fieldcontrol] ? item['fieldvalue' + item.fieldcontrol] : ''
      }
      else if (item.fieldcontrol === 4) {
        const rawVal = item['fieldvalue' + item.fieldcontrol]
        newFormValues["defaultcontrol" + item.fieldid] = rawVal != null ? Number(rawVal) : ''
      }
      else if (item.fieldcontrol === 6) {
        newFormValues["defaultcontrol" + item.fieldid] = item['fieldvalue' + item.fieldcontrol] ? item['fieldvalue' + item.fieldcontrol] : ''
      }
      else {
        newFormValues["defaultcontrol" + item.fieldid] = item['fieldvalue' + item.fieldcontrol] ?? ''
      }
    })

    reset(newFormValues)

    // If no guest is selected (new ticket), explicitly clear all fields so stale
    // values from a previous session don't persist regardless of effect batching
    const guestValue = newFormValues["defaultcontrol-1001"]
    if (!guestValue || guestValue?.label === 'Add New') {
      parsedData?.ticketfieldslist?.forEach(field => {
        if (field.fieldid === -1001) return
        setValue("defaultcontrol" + field.fieldid, field.fieldcontrol === 2 ? null : '')
      })
    }

    setLoading(false)
  }

  const handleClose = () => {
    fetchIdRef.current++ // invalidate any in-flight fetchGuestDetails
    setIsGuestOpen(false)
  }

  const onSubmit = async (formData: FormData) => {
    var fieldList = []
    const formKeys = Object.keys(formData)
    formKeys.map(key => {
      const fieldId = key.split("defaultcontrol").pop()
      var element = ticketData?.ticketfieldslist?.find(field => Number(field.fieldid) === Number(fieldId))
      const defaultValueControl = 'defaultcontrol' + fieldId
      var fieldDataObject = {fieldid: element.fieldid}

      if (formData && formData[defaultValueControl] != undefined || (typeof formData[defaultValueControl] === 'number' && !isNaN(formData[defaultValueControl]))
          || (typeof formData[defaultValueControl] === 'string' && formData[defaultValueControl]?.length > 0 )) {
        var fieldData = formData[defaultValueControl]

        if (element.fieldcontrol == 2) {
          fieldData = fieldData?.value ?? null
        }
        else if (element.fieldcontrol == 3) {
          fieldData = Number(formData[defaultValueControl])
        }
        else if (element.fieldcontrol == 4) {
          fieldData = Number(formData[defaultValueControl])
        }
        else if (element.fieldcontrol == 6) {
          if (formData[defaultValueControl]?.length > 0) {
            fieldData = formData[defaultValueControl]
          }
          else {
            fieldData = null
          }
        }

        if (element.fieldcontrol === 1 && typeof fieldData !== 'boolean') {
          // no selection
        } else {
          fieldDataObject['fieldvalue' + element.fieldcontrol] = fieldData
          fieldList.push(fieldDataObject)
        }
      }
    });

    const body = {eventid: eventId, genericid: genericid, fieldslist: fieldList}
    const {data} = await axios.put('/' + endpoint, body)
    const parsedData = JSON.parse(data.jsonString)

    console.log(parsedData)
    setIsGuestOpen(false)
  }

  const handleSelectionClick = async (value, fieldControlId, fieldData) => {
    setValue("defaultcontrol" + fieldData.fieldid, Number(value))
  }

  const handleUnassign = () => {
    setDialogObj({
      title: '',
      id: 0,
      msg: 'Are you sure you want to unassign this guest?'
    })
  }

  const handleReassign = () => {
    const newTicketData = {...ticketData}
    var ticket = newTicketData?.ticketfieldslist.find(ticket => ticket.fieldid === -1001)
    ticket.fieldreadonly = false
    setTicketData(newTicketData)
  }

  const unassignDialog = async () => {
    await handleUnassignConfirm(dialogObj.id)
  }

  const closeDialog = () => {
    setDialogObj({
      msg: '',
      id: 0,
      title: ""
    })
  }

  const handleUnassignConfirm = async (id: number) => {}

  const validateEmail = (ticketFieldData, value) => {
    if (ticketFieldData.fieldlabel.toLowerCase().includes('email')) {
      if (ticketFieldData.fieldrequired == 1) {
        return !emailRegex.test(value) ? "A valid email is required." : clearErrors("defaultcontrol" + ticketFieldData.fieldid)
      }
      else if (value?.length > 0) {
        return !emailRegex.test(value) ? "A valid email is required." : clearErrors("defaultcontrol" + ticketFieldData.fieldid)
      }
      else {
        clearErrors("defaultcontrol" + ticketFieldData.fieldid)
        return true
      }
    }
    else {
      clearErrors("defaultcontrol" + ticketFieldData.fieldid)
      return true;
    }
  }

  return (
      <>
        <Dialog open={isGuestOpen} maxWidth="xl" fullWidth={true} className={styles.dialog}>
          <>
            <Dialog
                open={dialogObj.msg.length > 0}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {dialogObj.title}
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                  {dialogObj.msg}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDialog}>Cancel</Button>
                <Button onClick={unassignEventTicket}>Unassign</Button>
              </DialogActions>
            </Dialog>
          </>
          <>
            <Dialog
                open={dialogMsg.active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {dialogMsg.msg}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDialog}>Ok</Button>
              </DialogActions>
            </Dialog>
          </>

          <DialogTitle>{ticketData.tickettitle}</DialogTitle>
          <LoadingBackdrop open={loading} />
          <DialogContent>
            <HookForm
                methods={formMethods}
                onSubmit={onSubmit}
                className={styles.itemsForm}
                formProps={{ id: 'guest-items-form' }}>

              {(ticketData.showbuttonreassign || ticketData.showbuttonunassign) &&
                  <Grid container spacing={1} style={{marginTop: '5px'}}>
                    {ticketData.showbuttonunassign &&
                        <Grid item xs={2} className={styles.selectcontrol}>
                          <InputLabel style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}}>
                            <Button
                                variant="contained"
                                size="large"
                                color="primary"
                                onClick={() => {handleUnassign()}}>Unassign Ticket
                            </Button>
                          </InputLabel>
                        </Grid>
                    }
                  </Grid>
              }

              <Grid container spacing={1} style={{marginTop: '5px'}}>
                {ticketData?.ticketfieldslist?.sort((a, b) => {
                  if (a.fieldrowgrouping !== b.fieldrowgrouping) {
                    return a.fieldrowgrouping - b.fieldrowgrouping
                  }
                  return a.fieldorder - b.fieldorder;
                }).map((ticketFieldData) => {

                  if (ticketFieldData.fieldcontrol === 1) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                          <SelectInput
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              label={formatLabel(ticketFieldData.fieldlabel)}
                              options={[
                                {label: 'Yes', value: true},
                                {label: 'No', value: false}
                              ]}
                              includeNone={false}
                              disabled={ticketFieldData.fieldreadonly}
                          />
                        </Grid>
                    )
                  }

                  if (ticketFieldData.fieldcontrol === 2) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}} key={"defaultcontrol" + ticketFieldData.fieldid}>
                          <Controller
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              control={control}
                              defaultValue={null}
                              rules={{ required: ticketFieldData.fieldrequired ? 'This field is required' : false }}
                              render={({ field, fieldState: { error } }) => (
                                  <Autocomplete
                                      {...field}
                                      size={'small'}
                                      options={getTicketLookupDataOptions(ticketFieldData.fieldid)}
                                      getOptionLabel={(option) => option?.label ?? ''}
                                      filterOptions={(opts, state) => {
                                        const inputValue = state.inputValue.toLowerCase()
                                        return opts.filter((option) =>
                                            option.label.toLowerCase().includes(inputValue)
                                        )
                                      }}
                                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                                      disabled={ticketFieldData.fieldreadonly}
                                      onChange={(_, newValue) => field.onChange(newValue)}
                                      renderOption={(props, option: selectOption) => (
                                          <li {...props} key={option.value}>
                                            {option.label}
                                          </li>
                                      )}
                                      renderInput={(params) => (
                                          <TextField size="small" {...params} label={formatLabel(ticketFieldData.fieldlabel)} required={!!ticketFieldData.fieldrequired} />
                                      )}
                                  />
                              )}
                          />
                        </Grid>
                    )
                  }

                  else if (ticketFieldData.fieldcontrol === 3) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                          <TextInput
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              textFieldProps={{ type: 'number' }}
                              label={formatLabel(ticketFieldData.fieldlabel)}
                              disabled={ticketFieldData.fieldreadonly}
                              defaultValue={""}
                              required={!!ticketFieldData.fieldrequired}
                          />
                        </Grid>
                    )
                  }
                  else if (ticketFieldData.fieldcontrol === 4) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                          <CurrencyTextField
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              label={formatLabel(ticketFieldData.fieldlabel)}
                              value={ticketFieldData["fieldvalue" + ticketFieldData.fieldcontrol]}
                              currencySymbol="$"
                              outputFormat="string"
                              textAlign={"left"}
                              variant="outlined"
                              onChange={(event, value) => handleSelectionClick(value, "defaultcontrol" + ticketFieldData.fieldid, ticketFieldData)}
                          />
                        </Grid>
                    )
                  }
                  else if (ticketFieldData.fieldcontrol === 5) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                          <TextInput
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              label={formatLabel(ticketFieldData.fieldlabel)}
                              disabled={ticketFieldData.fieldreadonly}
                              defaultValue={""}
                              required={!!ticketFieldData.fieldrequired}
                              rules={{
                                validate: (val) => (validateEmail(ticketFieldData, val)),
                              }}
                          />
                        </Grid>
                    )
                  }
                  else if (ticketFieldData.fieldcontrol === 6) {
                    return (
                        <Grid item xs={ticketFieldData.fieldwidth} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                          <TextInput
                              name={"defaultcontrol" + ticketFieldData.fieldid}
                              label={formatLabel(ticketFieldData.fieldlabel)}
                              textFieldProps={{ type: 'date' }}
                              disabled={ticketFieldData.fieldreadonly}
                              defaultValue={""}
                              required={!!ticketFieldData.fieldrequired}
                              rules={{
                                validate: (val) => (validateEmail(ticketFieldData, val)),
                              }}
                          />
                        </Grid>
                    )
                  }
                })}
              </Grid>
            </HookForm>
          </DialogContent>

          <DialogActions>
            <Button
                variant="contained"
                onClick={() => {handleClose()}}
                form="items-form">
              Close
            </Button>
            <Button
                variant="contained"
                className={styles.submitButton}
                type="submit"
                form="guest-items-form">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </>
  )
}